import {put, takeEvery, call} from 'redux-saga/effects';
import {
    FEEDBACK_QUALITY_DELETE,
    FEEDBACK_QUALITY_DELETE_REQUEST,
    FEEDBACK_QUALITY_DELETE_SUCCESS,
    FEEDBACK_QUALITY_DELETE_FAILURE
} from '../constants';
import Api, {ApiMethods} from 'feedback-system/middleware/api';

function* qualityFeedbackDelete(action: any) {
    try {
        yield put({type: FEEDBACK_QUALITY_DELETE_REQUEST});

        const data = yield call(Api.fetch, {
            endpoint: `relations/${action.payload.recipientId}`,
            method: ApiMethods.DELETE,
            body: action.payload.feedbackId
        });

        if (data.httpStatus === 204) {
            yield put({type: FEEDBACK_QUALITY_DELETE_SUCCESS, payload: action.payload, data});
            if (action.payload.feedbackId) {
                yield call(Api.fetch, {
                    endpoint: `feedback/${action.payload.feedbackId}`,
                    method: ApiMethods.DELETE
                });
            }
        } else {
            yield put({type: FEEDBACK_QUALITY_DELETE_FAILURE});
        }
    } catch (e) {
        yield put({type: FEEDBACK_QUALITY_DELETE_FAILURE, error: e});
    }
}

function* qualityFeedbackSagaDelete() {
    yield takeEvery(FEEDBACK_QUALITY_DELETE, qualityFeedbackDelete);
}

export default qualityFeedbackSagaDelete;
